import React, { useState } from "react";
import ViewTicketModal from "../../Container/Modal/ViewTicketModal";

// --- MOCK DATA (Unchanged) ---
const USER = {
   name: "Aarav Sharma",
   location: "Mumbai, India",
   stats: { attended: 12, upcoming: 3, active: 5, saved: 12 },
   avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2000"
};
const TICKETS = [
   {
      id: 1,
      type: "Corporate Gala",
      title: "Grand Hyatt Mumbai",
      date: "Dec 15, 2024 • 7:00 PM",
      venue: "Grand Hyatt Mumbai", // Added venue field for modal compatibility
      details: { label1: "ROW: A1", label2: "SEAT: 12", label3: "ENTRY: Gate 4" },
      seat: "ROW A1 - SEAT 12", // Added seat field for modal compatibility
      gate: "Gate 4", // Added gate field for modal compatibility
      qr: "dummy-qr"
   },
   {
      id: 2,
      type: "Tech Summit Nepal",
      title: "Hyatt Regency, KTM",
      date: "Jan 05, 2025 • 9:00 AM",
      venue: "Hyatt Regency, Kathmandu",
      details: { label1: "VIP PASS", label2: "TABLE: 05", label3: "ENTRY: Main" },
      seat: "TABLE: 05",
      gate: "Main",
      qr: "dummy-qr"
   },
   {
      id: 3,
      type: "Luxury Wedding Expo",
      title: "Taj Palace Delhi",
      date: "Feb 10, 2025 • 11:00 AM",
      venue: "Taj Palace, New Delhi",
      details: { label1: "GUEST", label2: "LOUNGE: B", label3: "ENTRY: West" },
      seat: "LOUNGE: B",
      gate: "West",
      qr: "dummy-qr"
   }
];

const HISTORY = [
   { id: 1, title: "Global Finance Forum 2024", date: "October 12 • St. Regis Mumbai", img: "https://images.unsplash.com/photo-1551818255-e6e10975bc17?q=80&w=2000", status: "Attended" },
   { id: 2, title: "SaaS Connect India", date: "August 24 • ITC Maratha", img: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=2000", status: "Attended" }
];

const RECOMMENDATIONS = [
   { id: 1, title: "Exclusive Maybach Launch", sub: "Invite-only • Worli Sea Face", img: "https://images.unsplash.com/photo-1617788138017-80ad40651399?q=80&w=2000" },
   { id: 2, title: "CEO Networking Dinner", sub: "March 12 • The Oberoi", img: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?q=80&w=2000" }
];

const HomeView = ({ onChangeView }) => {
   const [selectedTicket, setSelectedTicket] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);

   const handleOpenTicket = (ticket) => {
      setSelectedTicket(ticket);
      setIsModalOpen(true);
   };

   return (
      <>


         <div className="space-y-8 animate-fade-in-up font-sans text-[#0B1F33]">

            {/* --- CUSTOM STYLES --- */}
            <style>{`
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fade-in-up { animation: fadeInUp 0.5s ease-out forwards; }
      `}</style>

            {/* 1. PROFILE HEADER CARD */}
            <div className="bg-white rounded-[1.5rem] p-6 md:p-8 border border-gray-100 shadow-sm flex flex-col md:flex-row items-center justify-between gap-6">
               <div className="flex items-center gap-6 w-full md:w-auto">
                  <div className="relative">
                     <div className="w-20 h-20 rounded-full p-1 bg-gradient-to-br from-[#D4AF37] to-[#F4E096]">
                        <img src={USER.avatar} alt="Profile" className="w-full h-full rounded-full object-cover border-2 border-white" />
                     </div>
                     <div className="absolute bottom-0 right-0 bg-green-500 w-5 h-5 rounded-full border-2 border-white"></div>
                  </div>
                  <div>
                     <h1 className="text-2xl md:text-3xl font-black text-[#0B1F33]">Welcome back, {USER.name.split(' ')[0]}</h1>
                     <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 mt-1 text-sm text-gray-500 font-medium">
                        <span className="flex items-center gap-1"><span className="material-symbols-outlined text-base">location_on</span> {USER.location}</span>
                        <span className="hidden sm:block">•</span>
                        <span className="flex items-center gap-1"><span className="material-symbols-outlined text-base text-[#D4AF37]">verified</span> {USER.stats.attended} Events Attended</span>
                     </div>
                  </div>
               </div>
               <button onClick={() => onChangeView('profile')} className="w-full md:w-auto bg-[#D4AF37] hover:bg-[#b8952b] text-[#0B1F33] px-8 py-3 rounded-xl font-bold text-sm transition-colors shadow-md shadow-[#D4AF37]/20">
                  Edit Profile
               </button>
            </div>

            {/* 2. STATS ROW */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
               <div className="bg-white p-6 rounded-[1.5rem] border border-gray-100 shadow-sm flex items-start justify-between">
                  <div>
                     <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest mb-2">Upcoming Events</p>
                     <h3 className="text-4xl font-black text-[#0B1F33]">{USER.stats.upcoming}</h3>
                  </div>
                  <span className="material-symbols-outlined text-3xl text-[#D4AF37]">calendar_month</span>
               </div>

               <div className="bg-[#0B1F33] p-6 rounded-[1.5rem] shadow-xl shadow-[#0B1F33]/20 flex items-start justify-between relative overflow-hidden group">
                  <div className="relative z-10">
                     <p className="text-[11px] font-bold text-[#D4AF37] uppercase tracking-widest mb-2">Active Bookings</p>
                     <h3 className="text-4xl font-black text-white">{USER.stats.active}</h3>
                  </div>
                  <span className="material-symbols-outlined text-3xl text-[#D4AF37] relative z-10">confirmation_number</span>
                  <div className="absolute -right-4 -bottom-4 text-white/5 opacity-0 group-hover:opacity-100 transition-opacity">
                     <span className="material-symbols-outlined text-[8rem]">confirmation_number</span>
                  </div>
               </div>

               <div className="bg-white p-6 rounded-[1.5rem] border border-gray-100 shadow-sm flex items-start justify-between">
                  <div>
                     <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest mb-2">Saved Venues</p>
                     <h3 className="text-4xl font-black text-[#0B1F33]">{USER.stats.saved}</h3>
                  </div>
                  <span className="material-symbols-outlined text-3xl text-[#D4AF37]">bookmark</span>
               </div>
            </div>

            {/* 3. UPCOMING TICKETS (Scrollable) */}
            <div>
               <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-black text-[#0B1F33]">Upcoming Tickets</h2>
                  <button onClick={() => onChangeView('tickets')} className="text-xs font-bold text-[#D4AF37] hover:text-[#b39020] transition-colors">View All</button>
               </div>

               <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {TICKETS.map((ticket) => (
                     <div key={ticket.id} className="bg-[#0B1F33] rounded-[1.5rem] p-5 text-white shadow-lg relative flex flex-col h-full hover:-translate-y-1 transition-transform duration-300">
                        <div className="flex justify-between items-start mb-6">
                           <div>
                              <p className="text-[10px] font-bold text-[#D4AF37] uppercase tracking-wider mb-1">{ticket.type}</p>
                              <h3 className="text-lg font-bold leading-tight mb-2">{ticket.title}</h3>
                              <p className="text-xs text-gray-300">{ticket.date}</p>
                           </div>
                           <div className="bg-white p-2 rounded-xl flex-shrink-0">
                              <span className="material-symbols-outlined text-4xl text-[#0B1F33]">qr_code_2</span>
                           </div>
                        </div>

                        <div className="mt-auto">
                           <div className="border-t border-dashed border-white/20 mb-4"></div>

                           <div className="flex justify-between text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-4">
                              <span>{ticket.details.label1}</span>
                              <span>{ticket.details.label2}</span>
                              <span>{ticket.details.label3}</span>
                           </div>

                           <div className="flex gap-3">
                              <button
                                 onClick={() => handleOpenTicket(ticket)}
                                 className="flex-1 bg-[#D4AF37] hover:bg-[#c5a02e] text-[#0B1F33] py-2.5 rounded-lg text-xs font-bold uppercase tracking-wide transition-colors"
                              >
                                 View Ticket
                              </button>
                              <button className="px-3 bg-white/10 hover:bg-white/20 rounded-lg text-white transition-colors">
                                 <span className="material-symbols-outlined text-lg">download</span>
                              </button>
                           </div>
                        </div>
                     </div>
                  ))}
               </div>
            </div>

            {/* 4. SPLIT LAYOUT: HISTORY & RECOMMENDATIONS */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">

               <div className="lg:col-span-8 space-y-6">
                  <h2 className="text-xl font-black text-[#0B1F33]">Event History</h2>
                  <div className="space-y-4">
                     {HISTORY.map((event) => (
                        <div key={event.id} className="bg-white p-4 rounded-[1.5rem] border border-gray-100 shadow-sm flex flex-col sm:flex-row gap-4 items-center">
                           <div className="w-full sm:w-24 h-24 rounded-2xl overflow-hidden flex-shrink-0">
                              <img src={event.img} alt={event.title} className="w-full h-full object-cover" />
                           </div>
                           <div className="flex-1 text-center sm:text-left">
                              <h3 className="text-lg font-bold text-[#0B1F33]">{event.title}</h3>
                              <p className="text-sm text-gray-500 font-medium mb-3">{event.date}</p>
                              <div className="flex items-center justify-center sm:justify-start gap-4 text-xs font-bold text-[#D4AF37] cursor-pointer">
                                 <span className="flex items-center gap-1 hover:underline"><span className="material-symbols-outlined text-sm">chat_bubble</span> Leave a Review</span>
                                 <span className="flex items-center gap-1 hover:underline"><span className="material-symbols-outlined text-sm">refresh</span> Re-book Service</span>
                              </div>
                           </div>
                           <div className="px-3 py-1 bg-green-50 text-green-600 text-[10px] font-bold uppercase tracking-wider rounded-full self-start sm:self-center">
                              {event.status}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>

               <div className="lg:col-span-4">
                  <h2 className="text-xl font-black text-[#0B1F33] mb-6">Recommended</h2>
                  <div className="bg-[#0B1F33] rounded-[2rem] p-6 text-white relative overflow-hidden">
                     <div className="relative z-10">
                        <p className="text-[10px] font-bold text-[#D4AF37] uppercase tracking-[0.2em] mb-6">Based on your luxury profile</p>

                        <div className="space-y-4">
                           {RECOMMENDATIONS.map((rec) => (
                              <div key={rec.id} className="group cursor-pointer">
                                 <div className="h-32 rounded-xl overflow-hidden mb-3 relative">
                                    <img src={rec.img} alt={rec.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                                 </div>
                                 <h4 className="font-bold text-sm leading-tight group-hover:text-[#D4AF37] transition-colors">{rec.title}</h4>
                                 <p className="text-xs text-gray-400 mt-1">{rec.sub}</p>
                              </div>
                           ))}
                        </div>

                        <button className="w-full mt-8 py-3 rounded-xl border border-white/20 hover:bg-white/10 text-xs font-bold uppercase tracking-widest transition-colors">
                           Explore All Recommendations
                        </button>
                     </div>
                  </div>
               </div>

            </div>



         </div>
         {/* Ticket Modal */}
         <ViewTicketModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            ticket={selectedTicket}
         />
      </>
   );
};

export default HomeView;